import { useDeprecation as a } from "./useDeprecation.js";
function t(p) {
  p.forEach((r) => {
    const { props: e } = r || {};
    e?.propValue && e?.propValue !== e?.propDefaultValue && a(r, "props-name-deprecation-warning");
  });
}
function u(p) {
  p.forEach((r) => {
    const { props: e } = r || {};
    (!e.propName || !e?.deprecatedValue ? !1 : e?.propValue === e?.deprecatedValue) && a(r, "props-value-deprecation-warning");
  });
}
export {
  t as deprecatePropNames,
  u as deprecatePropValues
};
